<template>
  <v-container
    v-if="article"
    fluid
  >
    <v-row v-if="article.featured_media && getArticleImage(article, 'full')">
      <v-col
        class="text-center"
        cols="12"
      >
      <v-card
          class="synthesis-ui-blue-07 pa-4 pa-md-8 pa-lg-8 synthesis-section-border-radius mb-10"
          color="transparent"
          flat
        >
        <div class="d-flex">
          <v-btn
            :to="{name: 'Press'}"
            class="mb-4"
            depressed
            exact
            outlined
            medium
          >
            <div class="d-flex align-center" style="line-height: 10px;">
              <v-icon small class="mr-1">mdi-arrow-left</v-icon>
              <span>Back</span>
            </div>
          </v-btn>
        </div>
        <v-img
          :gradient="'to bottom, rgba(0,0,0,0) 75%, rgb(208, 217, 245, 1)'"
          :src="getArticleImage(article, 'full').source_url"
          class="rounded-t-xxl rounded-b-0"
          max-height="600"
        />

        <v-card
          class="synthesis-ui-blue-07 pa-4 pa-md-8 pa-lg-8 rounded-t-0 rounded-b-xxl"
          color="transparent"
          flat
        >
          <v-container
            class="synthesis-brand-dark-blue--text text-left"
            fluid
          >
            <v-row justify="center">
              <v-col
                cols="12"
                lg="8"
                md="10"
              >
                <v-card
                  class="mb-8"
                  flat
                >
                  <v-card-text>
                    <v-chip
                      class="ma-4 white--dark float-right mt-6"
                      label
                      small
                    >
                      {{ getArticleDate(article) }}
                    </v-chip>

                    <div
                      :class="sectionTitleClass"
                      class="py-4 synthesis-brand-dark-blue--text text-left font-weight-regular"
                      v-html="sanitizeText(article.title.rendered)"
                    />

                    <div
                      :class="sectionSubTitleClass"
                      class="synthesis-brand-dark-blue--text text-left font-weight-regular"
                      v-html="sanitizeText(article.content.rendered)"
                    />
                  </v-card-text>
                </v-card>
                <!-- Previous/Next Navigation -->
                <v-row class="mt-8">
                  <v-col cols="6" class="text-left">
                    <v-btn
                      v-if="previousArticle"
                      :to="{name: 'PressArticle', params: {slug: previousArticle.slug}}"
                      text
                      large
                    >
                      <v-icon small class="mr-2">mdi-arrow-left</v-icon>
                       <div style="line-height: 10px;">
                      Previous
                      </div>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      v-if="nextArticle"
                      :to="{name: 'PressArticle', params: {slug: nextArticle.slug}}"
                      text
                      large
                    >
                    <div style="line-height: 10px;">
                      Next
                      </div>
                      <v-icon small class="ml-2">mdi-arrow-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import i18nRouteMeta     from '@/mixins/i18n/i18nRouteMeta'
import CssClassFontSizes from '@/mixins/cssClassFontSizes'
import PressCommon       from '@/mixins/pressCommon'
import RecentArticles    from '@/theme/default/views/press/RecentArticles.vue'
import { clone }         from '@/lib/utils/helper'

export default {
  name      : 'PressArticle',
  components: { },
  directives: {},
  mixins    : [i18nRouteMeta, CssClassFontSizes, PressCommon],
  props     : {
    slug: {
      type   : String,
      default: ''
    }
  },
  dataStore: {
    PressArticles: 'Press.Articles'
  },
  enums: {},
  data () {
    return {
      article: null
    }
  },
  computed: {
    relatedArticles () {
      return this.shuffleArticles(this.slug)?.slice(0, 2) || []
    },
    currentArticleIndex () {
      if (!this.PressArticles || !this.article) return -1
      return this.PressArticles.findIndex(a => a.slug === this.article.slug)
    },
    previousArticle () {
      if (this.currentArticleIndex > 0) {
        return this.PressArticles[this.currentArticleIndex - 1]
      }
      return null
    },
    nextArticle () {
      if (this.currentArticleIndex >= 0 && this.currentArticleIndex < this.PressArticles.length - 1) {
        return this.PressArticles[this.currentArticleIndex + 1]
      }
      return null
    }
  },
  watch: {
    slug () {
      this.setArticle()
    },
    PressArticles () {
      this.setArticle()
    }
  },
  beforeCreate () {},
  created () {
    this.setArticle()
  },
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    setArticle () {
      this.article = this.getArticleBySlug(this.slug)
    },

    shuffleArticles () {
      const array = clone(this.PressArticles)

      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
      }
      return array
    }
  }
}
</script>

<style scoped>

</style>
